import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../core/api/api";
import axiosInstance from "../core/interceptor/http-interceptor-config";

export const getAgentViolationList = createAsyncThunk(
    "agent/getAgentViolationList",
    async () => {
      return await axiosInstance.get(Api.agent_violation_list);
    }
  );

  export const getAgentLevelScoringVsSentimentList = createAsyncThunk(
    "agent/getAgentLevelScoringVsSentimentList",
    async () => {
      return await axiosInstance.get(Api.agent_level_scoring_vs_sentiment_list);
    }
  );

  export const getPurposeOfCallDistributionList = createAsyncThunk(
    "agent/getPurposeOfCallDistributionList",
    async () => {
      return await axiosInstance.get(Api.purpose_of_call_distribution);
    }
  );